import React from 'react';
import { withJsonFormsLayoutProps } from '@jsonforms/react';
import { MaterialLayoutRenderer } from '@jsonforms/material-renderers';
import { Paper, Typography } from '@mui/material';  // Используем Paper для сохранения фона и стилей


const CustomGroupRenderer = (props) => {
  const { uischema, schema, path, visible, enabled, renderers, cells } = props;

  if (!visible) return null;

  const layoutProps = {
    elements: uischema.elements,
    schema,
    path,
    enabled,
    direction: 'column',
    visible,
    uischema,
    renderers,
    cells,
  };

  const width = uischema.options?.width ? uischema.options.width : undefined;

  return (
    <Paper 
      //variant="outlined"  
      sx={{ 
        p: 2,  
        mb: 4  // Margin-bottom 32px для отступа между группами 
      }}
    >
      <Typography 
        variant="h5" 
        sx={{ mb: 4, color: 'black', width: width }} 
      >
        {uischema.label}
      </Typography>
      <MaterialLayoutRenderer {...layoutProps} />
    </Paper>
  );
};

export default withJsonFormsLayoutProps(CustomGroupRenderer);

